module.exports = __webpack_public_path__ + "static/img/logo_itsapp.1291c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_itsapp.png
// module id = B9kR
// module chunks = 1